<template>
  <div>
    <TopNavBar @onToggleDrawer="toggleNavDrawerState">
      <template v-slot:breadcrumb>
        <slot name="breadcrumb"/>
      </template>
      <template v-slot:menu>
        <slot name="barmenu"/>
      </template>
    </TopNavBar>
    <TopNavDrawer :drawer-open="navDrawerOpen" @onDrawerChanged="updateNavDrawerState">
      <template v-slot:menu>
        <slot name="drawermenu"/>
      </template>
    </TopNavDrawer>
  </div>
</template>


<script>
import TopNavBar from '@/components/TopNavBar.vue'
import TopNavDrawer from '@/components/TopNavDrawer.vue'

export default {
  name: 'TopNav',
  components: {
    TopNavBar,
    TopNavDrawer
  },
  data () {
    return {
      navDrawerOpen: false
    }
  },
  methods: {
    toggleNavDrawerState: function () {
      this.navDrawerOpen = !this.navDrawerOpen
    },
    updateNavDrawerState: function (newState) {
      this.navDrawerOpen = newState
    }
  }
}
</script>
